module.exports = __webpack_public_path__ + "static/img/level08.52eb3b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/crown-crunch/level08.png
// module id = 0NXZ
// module chunks = 0